export {};

declare global {
    interface Window {
        AdobeDC?: {
            View: new (options: {
                clientId: string;
                divId: string;
                ReportSuiteID: string;
            }) => {
                previewFile: (options: {
                    content: {
                        location: {
                            url: string;
                        };
                    };
                    metaData: {
                        fileName: string;
                    }
                }, p: {
                    showAnnotationTools: boolean
                }) => void;
            };
        };
    }
}

function renderAdobePdfViewer() {
    const viewerElement = document.getElementById('adobe-dc-view');

    if (!viewerElement) {
        return;
    }

    const clientId = viewerElement.dataset.adobeClientId;
    const pdfUrl = viewerElement.dataset.pdfUrl;
    const fileName = viewerElement.dataset.pdfFilename;
    const ReportSuiteID = viewerElement.dataset.adobeReportSuiteId;

    if (!clientId || !pdfUrl || !fileName || !window.AdobeDC || !ReportSuiteID) {
        return;
    }

    const adobeDCView = new window.AdobeDC.View({
        clientId,
        divId: 'adobe-dc-view',
        ReportSuiteID,
    });

    adobeDCView.previewFile({
        content: {
            location: {
                url: pdfUrl,
            },
        },
        metaData: {
            fileName,
        },
    }, {showAnnotationTools: false});
}

export default function initAdobePdfViewer() {
    const viewerElement = document.getElementById('adobe-dc-view');

    if (!viewerElement) {
        return;
    }

    if (window.AdobeDC) {
        renderAdobePdfViewer();
        return;
    }

    document.addEventListener('adobe_dc_view_sdk.ready', renderAdobePdfViewer, {
        once: true,
    });
}